import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaPageView } from "@/lib/meta-pixel";

// LDT-692 · Carga el Píxel de Meta y manda un PageView en cada cambio de ruta
// de la SPA (el snippet oficial sólo lo manda en la primera carga). Se monta
// SÓLO con consentimiento de marketing (ConsentedMarketing en App.tsx) y
// `trackMetaPageView` decide el resto: sin VITE_META_PIXEL_ID o fuera del
// sitio público no carga nada. El script se inyecta desde el efecto, así que
// el HTML prerenderizado nunca lo lleva. No renderiza nada.
export default function MetaPixelLoader() {
  const { pathname } = useLocation();
  useEffect(() => {
    trackMetaPageView(pathname);
  }, [pathname]);
  return null;
}
